export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/go-icon.svg?d23a4b881abf2128ae246ab1ef33636a";